import type { FaireBrandEntity } from "../../entity_types/brand";

export const queensBeverageCo: FaireBrandEntity = {
  token: "queens-beverage-co",
  type: "brand",
  name: "Queens Beverage Co.",
  description: "Locally-sourced kombucha and craft beverages",
  rating: 4.7,
  location: "Queens, NY",
  minimumOrderDollars: 200,
  tags: ["kombucha", "organic", "local"],
  isInsider: true,
  categoryTokens: ["cat_food-beverages"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "entity-db-bootstrap",
  },
};
